import { createContext } from "react";
const ClinicContext = createContext();
export default ClinicContext;

